import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx"; // For Excel export
import { Dropdown, DropdownButton } from "react-bootstrap";
import Logo from "../logo.png";
import "../App.css";

const Inventory = () => {
  const navigate = useNavigate();
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filterCenter, setFilterCenter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [selectedClient, setSelectedClient] = useState("Treespoon"); // Default client
  const [weightFilter, setWeightFilter] = useState("");
  const [lengthFilter, setLengthFilter] = useState("");
  const [widthFilter, setWidthFilter] = useState("");
  const [depthFilter, setDepthFilter] = useState("");  const [token, setToken] = useState(process.env.REACT_APP_CLIENT_DIHTOKEN);
  const [isWeightInputVisible, setIsWeightInputVisible] = useState(false);
  const [isLengthInputVisible, setIsLengthInputVisible] = useState(false);
  const [isWidthInputVisible, setIsWidthInputVisible] = useState(false);
  const [isDepthInputVisible, setIsDepthInputVisible] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    Weight: false,
    Dimension: false,
  });
  const [showFieldDropdown, setShowFieldDropdown] = useState(false); // State to manage dropdown visibility
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  // Sorting function
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredInventory].sort((a, b) => {
      const valueA = a[key] || 0;
      const valueB = b[key] || 0;

      if (valueA < valueB) return direction === "asc" ? -1 : 1;
      if (valueA > valueB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredInventory(sortedData);
  };
  const parseSearchInput = (input) => {
    const conditions = [
      { symbol: ">=", regex: />=(\d+)/ },
      { symbol: "<=", regex: /<=(\d+)/ },
      { symbol: ">", regex: />(\d+)/ },
      { symbol: "<", regex: /<(\d+)/ },
      { symbol: "=", regex: /=(\d+)/ },
    ];
  
    for (const condition of conditions) {
      const match = input.match(condition.regex);
      if (match) {
        return {
          condition: condition.symbol,
          value: parseFloat(match[1]),
        };
      }
    }
  
    return null; // No condition found
  };
 const clients = [
    { name: "Bettr Performance", token: process.env.REACT_APP_CLIENT_BettrPerformance },
    { name: "Bodysocks", token: process.env.REACT_APP_CLIENT_BODYSOCKSTOKEN },
    { name: "Ceejay", token: process.env.REACT_APP_CLIENT_Ceejay },
    { name: "Charcoal", token: process.env.REACT_APP_CLIENT_Charcoal },
    { name: "DIH", token: process.env.REACT_APP_CLIENT_DIHTOKEN },
    { name: "DRMTLGY", token: process.env.REACT_APP_CLIENT_DRMTLGYTOKEN },
    { name: "EcoSoul", token: process.env.REACT_APP_CLIENT_EcoSoul },
    { name: "First Organic Healthcare", token: process.env.REACT_APP_CLIENT_FIRSTORGANICHEALTHCARE_TOKEN },
    { name: "Grace and Company", token: process.env.REACT_APP_CLIENT_GRACEANDCOMPANYTOKEN },
    { name: "IDAM", token: process.env.REACT_APP_CLIENT_IDAMTOKEN },
    { name: "khanal Foods", token: process.env.REACT_APP_CLIENT_KHANALFOODSTOKEN },
    { name: "Loftex", token: process.env.REACT_APP_CLIENT_LOFTEXTOKEN },
    { name: "Naturally Royal", token: process.env.REACT_APP_CLIENT_NATURALLYROYALTOKEN },
    { name: "OJOOK Care", token: process.env.REACT_APP_CLIENT_OJOOKCARETOKEN },
    { name: "Resaltz", token: process.env.REACT_APP_CLIENT_RESALZTOKEN },
            { name: "RISHABH99 LLC", token: process.env.REACT_APP_CLIENT_RISHABH99LLCTOKEN },

    { name: "Smartivity", token: process.env.REACT_APP_CLIENT_SMARTIVITYTOKEN },
    { name: "Splendid Udyog", token: process.env.REACT_APP_CLIENT_SPLENDIDUDYOGTOKEN },

    { name: "Tandem Design Co", token: process.env.REACT_APP_CLIENT_TANDEMDESIGNCOTOKEN },
    { name: "Treespoon", token: process.env.REACT_APP_CLIENT_TREESPOONTOKEN },
    { name: "Vedix Ayurveda", token: process.env.REACT_APP_CLIENT_VEDIXAYURVEDATOKEN },
    { name: "Warpfy", token: process.env.REACT_APP_CLIENT_WARPFYTOKEN }
];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let allInventoryData = [];
        let allProductData = [];
        let inventoryPage = 1;
        let productPage = 1;
        let hasMoreInventory = true;
        let hasMoreProducts = true;

        // Fetch all inventory data
        while (hasMoreInventory) {
          const inventoryResponse = await axios.get(
            `https://api.shipbob.com/1.0/inventory?page=${inventoryPage}&IsActive=true&IsDigital=false`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const inventoryData = inventoryResponse.data;
          if (inventoryData.length > 0) {
            allInventoryData = [...allInventoryData, ...inventoryData];
            inventoryPage++; // Move to next page
          } else {
            hasMoreInventory = false; // Stop if no more data
          }
        }

        // Fetch all product data
        while (hasMoreProducts) {
          const productResponse = await axios.get(
            `https://api.shipbob.com/1.0/product?page=${productPage}`,

            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const productData = productResponse.data;
          if (productData.length > 0) {
            allProductData = [...allProductData, ...productData];
            productPage++; // Move to next page
          } else {
            hasMoreProducts = false; // Stop if no more data
          }
        }

        // Merge inventory and product data
        const mergedData = allInventoryData.map((item) => {
          const productItem = allProductData.find((product) =>
            product.fulfillable_inventory_items?.some(
              (inventoryItem) => inventoryItem.id === item.id
            )
          );

          if (productItem) {
            const matchedFulfillableItem =
              productItem.fulfillable_inventory_items?.find(
                (inventoryItem) => inventoryItem.id === item.id
              );

            return {
              ...item,
              sku: productItem.sku || "N/A",
              sku_from_fulfillable: matchedFulfillableItem
                ? matchedFulfillableItem.sku
                : "N/A",
            };
          }
          return item;
        });

        setInventory(mergedData);
        setFilteredInventory(mergedData);
        setLoading(false);
      } catch (err) {
        setError("Error fetching data");
        console.error(err);
        setLoading(false);
      }
    };

    fetchData();
  }, [token]); // Dependency on token

  const parseFilter = (input) => {
    const conditions = [
      { symbol: ">=", regex: />=(\d+)/ },
      { symbol: "<=", regex: /<=(\d+)/ },
      { symbol: ">", regex: />(\d+)/ },
      { symbol: "<", regex: /<(\d+)/ },
      { symbol: "=", regex: /=(\d+)/ },
    ];
  
    // Check for conditions like >, <, >=, <=, =
    for (const condition of conditions) {
      const match = input.match(condition.regex);
      if (match) {
        return {
          condition: condition.symbol,
          value: parseFloat(match[1]),
        };
      }
    }
  
    // If no condition is found, treat the input as an exact match
    const exactMatch = input.match(/(\d+)/);
    if (exactMatch) {
      return {
        condition: "=",
        value: parseFloat(exactMatch[1]),
      };
    }
  
    return null; // No valid input found
  };
  const filterInventory = useCallback(() => {
    let updatedInventory = inventory
      .filter((item) => {
        const selectedCenterData =
          item.fulfillable_quantity_by_fulfillment_center.find((center) =>
            center.name.toLowerCase().includes(filterCenter.toLowerCase())
          );
  
        // If a center is selected and there's no matching center for the item, exclude it
        if (filterCenter && filterCenter !== "all" && !selectedCenterData) {
          return false;
        }
        return true;
      })
      .map((item) => {
        const selectedCenterData =
          item.fulfillable_quantity_by_fulfillment_center.find((center) =>
            center.name.toLowerCase().includes(filterCenter.toLowerCase())
          );
        if (filterCenter && selectedCenterData) {
          return {
            ...item,
            total_fulfillable_quantity: selectedCenterData.fulfillable_quantity,
            total_onhand_quantity: selectedCenterData.onhand_quantity,
            total_committed_quantity: selectedCenterData.committed_quantity,
            total_awaiting_quantity: selectedCenterData.awaiting_quantity,
            total_backordered_quantity:
              selectedCenterData.backordered_quantity || 0,
          };
        }
        return item;
      });
  
    // Apply weight filter if weightFilter is set
    const applyFilter = (filter, field) => {
      const condition = parseFilter(filter);
      if (condition) {
        const { condition: cond, value } = condition;
        updatedInventory = updatedInventory.filter((item) => {
          const itemValue = item.dimensions?.[field] || 0; // Use 0 as fallback if value is undefined
  
          switch (cond) {
            case ">":
              return itemValue > value;
            case "<":
              return itemValue < value;
            case ">=":
              return itemValue >= value;
            case "<=":
              return itemValue <= value;
            case "=":
              return itemValue === value;
            default:
              return true;
          }
        });
      }
    };
  
    // Apply filters for weight and dimensions
    applyFilter(weightFilter, "weight");
    applyFilter(lengthFilter, "length");
    applyFilter(widthFilter, "width");
    applyFilter(depthFilter, "depth");
  
    // Apply general search filter
    if (filterSearch) {
      updatedInventory = updatedInventory.filter(
        (item) =>
          item.name.toLowerCase().includes(filterSearch.toLowerCase()) ||
          item.id.toString().includes(filterSearch) ||
          (item.sku &&
            item.sku.toLowerCase().includes(filterSearch.toLowerCase())) ||
          (item.sku_from_fulfillable &&
            item.sku_from_fulfillable
              .toLowerCase()
              .includes(filterSearch.toLowerCase()))
      );
    }
  
    setFilteredInventory(updatedInventory);
  }, [inventory, filterCenter, filterSearch, weightFilter, lengthFilter, widthFilter, depthFilter]);

  useEffect(() => {
    filterInventory();
  }, [filterInventory]);

  // Event handlers for filters
  useEffect(() => {
    filterInventory();
  }, [filterCenter, filterSearch]);

  const handleExport = () => {
    const dataToExport = filteredInventory.map((item, index) => {
      const row = {
        Index: index + 1,
        ItemName: item.name,
        SKU: item.sku || "N/A",
        InventoryID: item.id,
        FulfillableQuantity: item.total_fulfillable_quantity,
        OnhandQuantity: item.total_onhand_quantity,
        CommittedQuantity: item.total_committed_quantity,
        AwaitingQuantity: item.total_awaiting_quantity,
        BackorderedQuantity: item.total_backordered_quantity,
      };

      // Conditionally add Weight field
      if (selectedFields.Weight) {
        row.Weight = item.dimensions?.weight || "N/A";
      }

      // Conditionally add Dimension fields
      if (selectedFields.Dimension) {
        row.Length = item.dimensions?.length || "N/A";
        row.Width = item.dimensions?.width || "N/A";
        row.Depth = item.dimensions?.depth || "N/A";
      }

      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inventory");
    XLSX.writeFile(wb, "inventory.xlsx");
  };

  const handleClientChange = (e) => {
    const client = clients.find((c) => c.name === e.target.value);
    if (client) {
      setSelectedClient(client.name);
      setToken(client.token);
    }
  };

  const handleFieldToggle = (field) => {
    setSelectedFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  if (loading) {
    return (
      <div className="loading-container" style={{ backgroundColor: "#f0f0f0" }}>
        <img
          src={Logo}
          alt="Loading"
          className="loading-icon"
          style={{ width: "250px", height: "150px" }}
        />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
   <div
  style={{
    backgroundColor: "#E0F7FA",
    padding: "20px",
    borderRadius: "20px",
    minHeight: "100vh",
    height: "auto",
  }}
>
  <div className="container my-4">
    {/* Header Section */}
    <div className="d-flex justify-content-center position-relative mb-4">
      <h1 className="text-dark mb-0">Inventory</h1>
      <div className="position-absolute end-0">
        <DropdownButton
          variant="primary"
          title="Switch"
          size="sm"
          className="shadow-sm"
        >
          <Dropdown.Item onClick={() => navigate("/Receiving")}>
            Receiving
          </Dropdown.Item>
        </DropdownButton>
      </div>
    </div>

    {/* Filters */}
    <div className="mb-4 row">
      <div className="col-md-3">
        <label className="form-label">Select Client:</label>
        <select
          value={selectedClient}
          onChange={handleClientChange}
          className="form-select"
        >
          {clients.map((client) => (
            <option key={client.name} value={client.name}>
              {client.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-3">
        <label className="form-label">Fulfillment Center:</label>
        <select
          value={filterCenter}
          onChange={(e) => setFilterCenter(e.target.value)}
          className="form-select"
        >
          <option value="all">All</option>
          <option value="Dallas">Dallas</option>
          <option value="Philadelphia">Philadelphia</option>
          <option value="Fresno">Fresno</option>
          <option value="Ramona">Ramona</option>
        </select>
      </div>

      <div className="col-md-3">
        <label className="form-label">Search:</label>
        <input
          type="text"
          value={filterSearch}
          onChange={(e) => setFilterSearch(e.target.value)}
          className="form-control"
          placeholder="Enter search"
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Select Fields to Display:</label>
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            onClick={() => setShowFieldDropdown(!showFieldDropdown)}
          >
            Select Fields
          </button>
          <div
            className={`dropdown-menu ${showFieldDropdown ? "show" : ""}`}
            style={{ padding: "10px" }}
          >
            {Object.keys(selectedFields).map((field) => (
              <div key={field} className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={selectedFields[field]}
                  onChange={() => handleFieldToggle(field)}
                  id={field}
                />
                <label className="form-check-label" htmlFor={field}>
                  {field}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* Export Button */}
    <div className="mb-4 text-end">
      <button className="btn btn-success shadow-sm" onClick={handleExport}>
        Export to Excel
      </button>
    </div>

    <div className="table-responsive" style={{ overflowX: "auto" }}>
      <table 
        className="styled-table" 
        style={{ 
          width: "100%", 
          tableLayout: "fixed",
          borderCollapse: "collapse"
        }}
      >
<thead style={{ backgroundColor: "red", color: "white" }}>
  <tr>
    <th style={{ minWidth: "50px", width: "50px", whiteSpace: "normal" }}>NO</th>
    <th style={{ minWidth: "150px", width: "auto", whiteSpace: "normal" }}>Item Name</th>
    <th 
      style={{ 
        minWidth: "120px", 
        width: "auto",
        whiteSpace: "normal",
        cursor: "pointer"
      }}
      onClick={() => handleSort("sku")}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>SKU</span>
        {sortConfig.key === "sku" && (
          <span style={{ marginLeft: "4px" }}>
            {sortConfig.direction === "asc" ? "↑" : "↓"}
          </span>
        )}
      </div>
    </th>
    <th style={{ minWidth: "120px", width: "auto", whiteSpace: "normal" }}>Inventory ID</th>
    
    {/* Quantity Columns */}
     {["total_fulfillable_quantity", "total_onhand_quantity", "total_committed_quantity", 
      "total_awaiting_quantity", "total_backordered_quantity"].map((field) => {
      const labelMap = {
        'total_fulfillable_quantity': 'Fulfillable',
        'total_onhand_quantity': 'Onhand',
        'total_committed_quantity': 'Committed',
        'total_awaiting_quantity': 'Awaiting',
        'total_backordered_quantity': 'Backorder'
      };
      return (
        <th 
          key={field}
          style={{ 
            minWidth: "80px", 
            width: "auto",
            whiteSpace: "normal",
            cursor: "pointer"
          }}
          onClick={() => handleSort(field)}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{labelMap[field]}</span>
            {sortConfig.key === field && (
              <span style={{ marginLeft: "4px" }}>
                {sortConfig.direction === "asc" ? "↑" : "↓"}
              </span>
            )}
          </div>
        </th>
      );
    })}

    {/* Weight Column */}
    {selectedFields.Weight && (
      <th style={{ minWidth: "80px", width: "auto", cursor: "pointer" }}>
        <div style={{ whiteSpace: "normal" }}>
          <div 
            onClick={() => { 
              handleSort("weight"); 
              setIsWeightInputVisible(!isWeightInputVisible); 
            }}
            style={{ marginBottom: isWeightInputVisible ? "4px" : 0 }}
          >
            Weight (OZ)
          </div>
          {isWeightInputVisible && (
            <input
              type="text"
              value={weightFilter}
              onChange={(e) => setWeightFilter(e.target.value)}
              className="form-control form-control-sm"
              style={{ 
                width: "100%", 
                margin: "0 auto",
                maxWidth: "80px"
              }}
            />
          )}
        </div>
      </th>
    )}

    {/* Dimension Columns */}
    {selectedFields.Dimension && (
      <>
        {["length", "width", "depth"].map((dimension) => {
          const isVisible = dimension === "length" ? isLengthInputVisible : 
                          dimension === "width" ? isWidthInputVisible : 
                          isDepthInputVisible;
          const setIsVisible = dimension === "length" ? setIsLengthInputVisible : 
                             dimension === "width" ? setIsWidthInputVisible : 
                             setIsDepthInputVisible;
          const setFilter = dimension === "length" ? setLengthFilter : 
                          dimension === "width" ? setWidthFilter : 
                          setDepthFilter;
          const filter = dimension === "length" ? lengthFilter : 
                        dimension === "width" ? widthFilter : 
                        depthFilter;

          return (
            <th 
              key={dimension}
              style={{ 
                minWidth: "80px", 
                width: "auto",
                cursor: "pointer"
              }}
            >
              <div style={{ whiteSpace: "normal" }}>
                <div 
                  onClick={() => { 
                    handleSort(dimension); 
                    setIsVisible(!isVisible); 
                  }}
                  style={{ marginBottom: isVisible ? "4px" : 0 }}
                >
                  {`${dimension.charAt(0).toUpperCase() + dimension.slice(1)} (in)`}
                </div>
                {isVisible && (
                  <input
                    type="text"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ 
                      width: "100%", 
                      margin: "0 auto",
                      maxWidth: "80px"
                    }}
                  />
                )}
              </div>
            </th>
          );
        })}
      </>
    )}
  </tr>
</thead>
        <tbody>
          {filteredInventory.map((item, index) => (
            <tr key={item.id}>
              <td style={{
                maxWidth: "50px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "8px"
              }}>{index + 1}</td>
              
              <td style={{
                maxWidth: "150px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "8px"
              }} title={item.name}>{item.name}</td>
              
              <td style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "8px"
              }} title={item.sku || "N/A"}>{item.sku || "N/A"}</td>
              
              <td style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                padding: "8px"
              }}>{item.id}</td>
              
              <td style={{ padding: "8px" }}>{item.total_fulfillable_quantity}</td>
              <td style={{ padding: "8px" }}>{item.total_onhand_quantity}</td>
              <td style={{ padding: "8px" }}>{item.total_committed_quantity}</td>
              <td style={{ padding: "8px" }}>{item.total_awaiting_quantity}</td>
              <td style={{ padding: "8px" }}>{item.total_backordered_quantity}</td>

              {selectedFields.Weight && (
                <td style={{ padding: "8px" }}>
                  {item.dimensions?.weight || "N/A"}
                </td>
              )}

              {selectedFields.Dimension && (
                <>
                  <td style={{ padding: "8px" }}>
                    {item.dimensions?.length || "N/A"}
                  </td>
                  <td style={{ padding: "8px" }}>
                    {item.dimensions?.width || "N/A"}
                  </td>
                  <td style={{ padding: "8px" }}>
                    {item.dimensions?.depth || "N/A"}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
</div>
  );
};

export default Inventory;
